// components/report/createReport.js
import firebase from "firebase/app";
import "firebase/firestore";
import { db } from "../../firebase/firebase.utils";

export const REASONS = ["Spam", "Harassment or bullying", "Inappropriate content", "Impersonation", "Other"];

// target is captured when the form opens, so switching chats cannot retarget it.
export async function createReport(reporterId, target, reason, details = "") {
  if (!reporterId || !target?.targetId || !target?.reportedUserId ||
      !["message", "post", "user"].includes(target.targetType) ||
      !REASONS.includes(reason)) {
    throw new Error("Missing report information.");
  }
  const data = {
    reporterId,
    reportedUserId: target.reportedUserId,
    targetType: target.targetType,
    targetId: target.targetId,
    targetPath: target.targetPath || "",
    reason,
    details: details.trim().slice(0, 2000),
    messageText: String(target.messageText || "").slice(0, 12000),
    messageCreatedAt: target.messageCreatedAt || null,
    // Keep only published attachment data, never local file URIs.
    attachments: (target.attachments || []).slice(0, 10).map((a) => ({
      kind: a.kind || "",
      url: a.url || "",
      thumbUrl: a.thumbUrl || "",
      name: a.name || "",
      title: a.title || "",
      stickerKey: a.stickerKey || "",
      latitude: a.latitude ?? null,
      longitude: a.longitude ?? null,
    })),
    status: "open",
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
  };
  return db.collection("reports").add(data);
}
